import script from "./Hakmilik.vue?vue&type=script&setup=true&lang=js"
export * from "./Hakmilik.vue?vue&type=script&setup=true&lang=js"

import "./Hakmilik.vue?vue&type=style&index=0&id=ad630bca&lang=css"

const __exports__ = script;

export default __exports__